import { all, takeLatest, take } from "redux-saga/effects";

import { REHYDRATE } from "redux-persist/lib/constants";
/**
 * Types
 */
import { UserTypes } from "../ducks/user";
import { Types as NotificationsTypes } from "../ducks/notifications/types";
import { Types as PaulChatTypes } from "../ducks/paulChat/types";
import { Types as NewCourseTypes } from "../ducks/newCourse/types";

/**
 * Sagas
 */
import { getProfile } from "./user";
import { getNotification, countNotificationsNotRead } from "./notifications";

import { addButtonFeedback, didSubjectChanged, sendFeedback } from "./paulChat";
import {
  getCourse as getNewCourse,
  reloadCourse as reloadNewCourse,
  getCourseCertificate
} from "./newCourse";

export default function* rootSaga() {
  yield take(REHYDRATE); // Wait for rehydrate to prevent sagas from running with empty store

  yield all([
    takeLatest(UserTypes.ProfileTypes.GET_PROFILE_REQUEST, getProfile),

    takeLatest(NotificationsTypes.GET_NOTIFICATION_REQUEST, getNotification),
    takeLatest(
      NotificationsTypes.GET_COUNT_NOTIFICATIONS_REQUEST,
      countNotificationsNotRead
    ),
    takeLatest(PaulChatTypes.ADD_BUTTON_FEEDBACK, addButtonFeedback),
    takeLatest(PaulChatTypes.ON_SUBJECT_CHANGED, didSubjectChanged),
    takeLatest(PaulChatTypes.SEND_FEEDBACK_REQUEST, sendFeedback),

    takeLatest(NewCourseTypes.GET_COURSE_REQUEST, getNewCourse),
    takeLatest(NewCourseTypes.RELOAD_COURSE_DATA, reloadNewCourse),
    takeLatest(NewCourseTypes.GET_COURSE_CERTIFICATE_REQUEST, getCourseCertificate)
  ]);
}
